// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3RFrO","title":"Images90_title__KtWbT","images":"Images90_images__8pDdk"};